import { Spin } from 'antd';

const Spinner = ()=>{
    return (<div><Spin/></div>)
}
export default Spinner;